import { Link } from "react-scroll";

export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hey, I'm Van Maclloyd Fayah</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">Full Stack</span>{" "}
            <br />
            Developer and ICT Educator
          </h1>
          <p className="hero--section-description">
             Holder of Bachelor of Education in Computer Sciences with Credit from University Of Malawi.
            <br />And over two years of experience in application development, database management, system integration and Teaching.
          </p>
        </div>
        <button className="btn btn-primary"><Link spy={true} smooth={true} offset={-70}
        duration={500} to="Contact">Get In Touch</Link></button>
      </div>
      <div className="hero--section--img">
        <img src="./img/hero.png" alt="Hero Section" />
      </div>
    </section>
  );
}
